import React from "react";
import BoardOfTrustees from "../components/About/BoardOfTrustee";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const Team = () => {
  return (
    <div>
      <Navbar />
      <BoardOfTrustees />
      <FullScreenImage />
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default Team;
